// extracted by mini-css-extract-plugin
module.exports = {"FilterDrawerContent__legend--hidden":"FilterDrawerContent__legend--hidden__3mVHK"};